var map = {
	"./AED.svg": 3548,
	"./AUD.svg": 7868,
	"./AZN.svg": 4691,
	"./CAD.svg": 1286,
	"./CHF.svg": 8755,
	"./CNY.svg": 6442,
	"./EUR.svg": 1630,
	"./GBP.svg": 1603,
	"./INR.svg": 203,
	"./IQD.svg": 160,
	"./JPY.svg": 77,
	"./MYR.svg": 9562,
	"./RUP.svg": 8715,
	"./SAR.svg": 2104,
	"./SEK.svg": 8893,
	"./TRY.svg": 1693,
	"./USD.svg": 5546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5038;